'use es6';

export const KBArticles = {
  CONNECT_FACEBOOK_ADS_ACCOUNT: 'CONNECT_FACEBOOK_ADS_ACCOUNT',
  CONNECT_ADWORDS_ADS_ACCOUNT: 'CONNECT_ADWORDS_ADS_ACCOUNT',
  CONNECT_LINKEDIN_ADS_ACCOUNT: 'CONNECT_LINKEDIN_ADS_ACCOUNT',
  AD_TRACKING: 'AD_TRACKING',
  FACEBOOK_ADS_TROUBLESHOOT: 'FACEBOOK_ADS_TROUBLESHOOT',
  LINKEDIN_ADS_TROUBLESHOOT: 'LINKEDIN_ADS_TROUBLESHOOT',
  GOOGLE_ADS_TROUBLESHOOT: 'GOOGLE_ADS_TROUBLESHOOT',
  CREATE_FACEBOOK_AD_SEQUENCES: 'CREATE_FACEBOOK_AD_SEQUENCES'
};
export const KBArticlesToURLs = {
  [KBArticles.CONNECT_FACEBOOK_ADS_ACCOUNT]: 'https://knowledge.hubspot.com/ads/connect-your-facebook-ads-account-to-hubspot',
  [KBArticles.CONNECT_ADWORDS_ADS_ACCOUNT]: 'https://knowledge.hubspot.com/ads/connect-your-google-ads-account-to-hubspot#connect-your-google-ads-account',
  [KBArticles.CONNECT_LINKEDIN_ADS_ACCOUNT]: 'https://knowledge.hubspot.com/ads/connect-your-linkedin-ads-account-to-hubspot',
  [KBArticles.AD_TRACKING]: 'https://knowledge.hubspot.com/ads/ad-tracking-in-hubspot',
  [KBArticles.FACEBOOK_ADS_TROUBLESHOOT]: 'https://knowledge.hubspot.com/ads/facebook-ads-account-troubleshooting',
  [KBArticles.LINKEDIN_ADS_TROUBLESHOOT]: 'https://knowledge.hubspot.com/ads/troubleshoot-your-linkedin-ads-account-connection',
  [KBArticles.GOOGLE_ADS_TROUBLESHOOT]: 'https://knowledge.hubspot.com/ads/troubleshoot-your-google-ads-account-connection',
  [KBArticles.CREATE_FACEBOOK_AD_SEQUENCES]: 'https://knowledge.hubspot.com/ads/create-facebook-ad-sequences-in-hubspot'
};
export const FB_CONVERSION_API_LEARN_MORE_LINK = 'https://www.facebook.com/business/help/2041148702652965?id=818859032317965';